





























































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
class PageCollectionCodeTrackingRequest extends PageRequest {
  id: number;
}
@Component
export default class ViewCollectionCode extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "collectionCodeTracking";
  collectionCode: any = null;
  pagerequest: PageCollectionCodeTrackingRequest =
    new PageCollectionCodeTrackingRequest();

  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  get store() {
    return this.$store.state.collectionCodeTracking;
  }
  cancel() {
    (this.$refs.viewCollectionCodeForm as any).resetFields();
    this.$emit("input", false);
    this.$root.$router.push({ name: "collectionCode" });
  }
  get list() {
    var re = this.$store.state.collectionCodeTracking.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.id = this.id;

  }
  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      this.$store
        .dispatch({
          type: `collectionCode/getInfo`,
          data: { code: this.code },
        })
        .then((result) => {
          this.collectionCode = result;
          this.id = this.collectionCode.id;
          this.searchData();
        });
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  get columns() {
    return [
      {
        title: Util.L("Order"),
        width: 50,
        key: "orderNo",
      },
      {
        title: Util.L("Type"),
        key: "actionTypeName",
        width: 150,
      },
      {
        title: Util.L("Content"),
        key: "objectName",
        render: (h: any, params: any) => {
          var objectText =
            params.row.objectCode == null
              ? params.row.object
              : `${params.row.objectCode} - ${params.row.object}`;
  
          if (
            params.row.newStatusCode === "STAMP_RCL" &&
            !_.isNil(params.row.reasonDescription) &&
            !_.isEmpty(params.row.reasonDescription)
          )
          return h(
              "span",
              `${Util.toViewTimeDateString(
                params.row.creationTime
              )};  Tại ${objectText};  Lý do thu hồi: ${
                params.row.reasonDescription
              }`
            );
          if (
            params.row.actionTypeCode === "DEACTIVATE" &&
            !_.isNil(params.row.reasonDescription) &&
            !_.isEmpty(params.row.reasonDescription)
          )
            return h(
              "span",
              `${Util.toViewTimeDateString(
                params.row.creationTime
              )};  Tại ${objectText};  Lý do hủy: ${
                params.row.reasonDescription
              }`
            );
          if (
            params.row.actionTypeCode === "STAMP_ATV" &&
            !_.isNil(params.row.reasonDescription) &&
            !_.isEmpty(params.row.reasonDescription)
          )
            return h(
              "span",
              `${Util.toViewTimeDateString(
                params.row.creationTime
              )};  Tại ${objectText};  Lý do : ${params.row.reasonDescription}`
            );
          return h(
            "span",
            `${Util.toViewTimeDateString(
              params.row.creationTime
            )};  Tại ${objectText}`
          );
        },
      },
    ];
  }
}
